import React from "react";
import PropTypes from "prop-types";

import Icon from "./Icon";
import Content from "./Content";
import Actions from "./Actions";

import DragIcon from "ui/DragIcon";

import Box from "@mui/material/Box";

const Block = ({ pageElement, handleDeleteRequest, handleUpdateRequest }) => {
  
  const { id, content, element_type, link_title, settings, image_url } = pageElement;

  return (
    <Box
      sx={{
        mr: 2,
        ml: 2,
        p: 2,
        border: "1px solid rgba(0,0,0,0.1)",
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "&:hover": {
          boxShadow: 2,
        },
        width: "100%",
        gap: 1,
      }}
    >
      <DragIcon />

      <Box
        sx={{
          width: "100%",
          minHeight: 30,
          borderRadius: 1,
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Icon type={element_type} image_url={image_url} />

        <Content
          type={element_type}
          content={content}
          settings={settings}
          link_title={link_title}
        />

        <Actions
          onUpdate={() => handleUpdateRequest(pageElement)}
          onDelete={() => handleDeleteRequest(id)}
        />
      </Box>
    </Box>
  );
};

Block.propTypes = {
  pageElement: PropTypes.object,
  handleDeleteRequest: PropTypes.func,
  handleUpdateRequest: PropTypes.func,
};

export default Block;
